import React from 'react'
import { Link,useLocation } from 'react-router-dom';

const Subitem = ({to,title}) => {
  const currentRoute = useLocation().pathname.toLowerCase();
  return (
    
    <Link to={to} className={currentRoute.includes(to)? "admin_siderbar_subitem_wrapper active" : "admin_siderbar_subitem_wrapper" }>
        <div className='admin_sidebar_subitem_container'>
            <div className='admin_sidebar_subitem_border'></div>
            <div className='admin_sidebar_subitem'>
                <h6>{title}</h6>
            </div>
        </div>
    </Link>
  )
}

export default Subitem
